import React, { useState, useCallback, useEffect } from "react";
import List from "../workingPartUnitList";
import Filter from "../workingPartUnitFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import * as UserServices from "../../../../services/UserServices";
import * as WorkingPartServices from "../../../../services/WorkingPartService";
import moment from "moment-timezone";
import * as XLSX from "xlsx";
import * as TaskService from "../../../../services/TaskService";
import { converToTime, msToMinutes } from "../../../../utils/formats/number";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { useSelector } from "react-redux";
import { getFilterPartDesSelector } from "../../../../store/selectors/navSelector";
import * as GeneralServices from "../../../../services/GeneralServices";
import { SET_FILTER_PART_DES } from "../../../../constants";

const queryClient = new QueryClient();

const WorkingPartUnitFilterListContainer = (props) => {
  const { isTechnical } = props;
  const filters = useSelector(getFilterPartDesSelector);

  const { t, i18n } = useTranslation();
  // const [filters, setFilters] = useState(undefined);
  const [tasks, setTasks] = useState([]);
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.workingPartUnit.title") },
  ];

  const loadTasks = useCallback(async () => {
    const resultTasks = await TaskService.listAllTask();
    if (resultTasks) {
      setTasks(resultTasks);
    }
  }, []);

  useEffect(() => {
    loadTasks();
  }, [loadTasks]);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    GeneralServices.setFilter(undefined, SET_FILTER_PART_DES);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    // setFilters(newFilter);
    GeneralServices.setFilter(newFilter, SET_FILTER_PART_DES);
  };

  const handlerFilterUser = async (value) => {
    let filter = {
      filters: {
        name: value,
      },
    };

    let result = await UserServices.filterAllUser(filter);
    if (result && result.length === 0) {
      if (filters?.userUuid) {
        filter = {
          filters: {
            uuid: filters.userUuid,
          },
        };
        result = await UserServices.filterAllUser(filter);
      }
    }
    return result;
  };

  const exportToExcel = async () => {
    const filter = {
      filters,
      sort: "-date",
    };
    WorkingPartServices.listToExportWorking(filter).then((result) => {
      let total = 0;
      let totalPlants = 0;
      const data = result.map((item) => {
        total = total + item.taskTime;
        totalPlants += item.numPlants;
        const task = i18n.language === "pt" ? item.task.namePt : item.task.name;

        return {
          A: item.user.completeName,
          B: moment(item.initTime).format("DD-MM-YYYY HH:mm"),
          C: moment(item.endTime).format("DD-MM-YYYY HH:mm"),
          D: converToTime(item.taskTime),
          E: msToMinutes(item.taskTime),
          F: task,
          G: item.numPlants,
          H: item?.code?.location?.name || "DESCONOCIDO",
          I: item?.code?.variety?.name,
          J: item?.code?.batch?.code,
          K: item?.code?.article?.code,
          L: item?.code?.article?.name,
          M: item?.code?.location?.vivero?.name || "DESCONOCIDO",
        };
      });

      data.push({
        A: "",
        B: "",
        C: "",
        D: "",
        E: "",
        F: "",
        G: "",
        H: "",
        I: "",
        J: "",
        K: "",
        L: "",
        M: "",
      });
      data.push({
        A: "TOTAL",
        B: "",
        C: "",
        D: converToTime(total),
        E: msToMinutes(total),
        F: "",
        G: totalPlants,
        H: "",
        I: "",
        J: "",
        K: "",
        L: "",
        M: "",
      });

      data.unshift({
        A: t("forms.workingPartUnit.table.heads.user"),
        B: t("forms.workingPartUnit.table.heads.initTime"),
        C: t("forms.workingPartUnit.table.heads.endTime"),
        D: t("forms.workingPartUnit.table.heads.taskTime"),
        E: t("forms.workingPartUnit.table.heads.minutes"),
        F: t("forms.workingPartUnit.table.heads.task"),
        G: t("forms.workingPartUnit.table.heads.numPlants"),
        H: t("forms.workingPartUnit.table.heads.location"),
        I: t("forms.workingPartUnit.table.heads.variety"),
        J: t("forms.workingPartUnit.table.heads.code"),
        K: t("forms.workingPartUnit.table.heads.article"),
        L: t("forms.workingPartUnit.table.heads.articleDescription"),
        M: t("forms.workingPartUnit.table.heads.vivero"),
      });

      const filename = `Parte_export_${moment(new Date()).format(
        "DDMMyyyyHHmm",
      )}`;
      const sheetName = t("forms.workingPartUnit.titleExcel");
      var ws = XLSX.utils.json_to_sheet(data, {
        header: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });
      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename + ".xlsx");
    });
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.workingPartUnit.title")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onFilterUser={handlerFilterUser}
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            isTechnical={isTechnical}
            tasks={tasks}
            initialValues={filters}
          />
        </div>
      </div>
      {!isTechnical && (
        <div className="row justify-content-center mt-4 no-margin">
          <div className="col-12 col-md-11 text-end ">
            <button
              type="button"
              className="btn btn-md btn-secondary"
              onClick={() => exportToExcel()}
            >
              <i className="fa-solid fa-file-excel icon-button"></i>{" "}
              {t("exportFileExcel")}
            </button>
          </div>
        </div>
      )}

      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
    </>
  );
};

WorkingPartUnitFilterListContainer.propTypes = {};

export default WorkingPartUnitFilterListContainer;
